// extracted by mini-css-extract-plugin
module.exports = {"quickShopLink":"NB-z","button":"OB-z","disabled":"PB-z"};